import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";

export default function ButtonGrey({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#D5DCDF',
        },
      }}
    >
      <Button type={"primary"} {...props}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
